import React from "react";
import i18n from "i18next";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { api } from "@/utils/api";
import ConfirmBody from "@/react-components/Confirm/Body";
import ConfirmUpdateTips from "@/react-components/Confirm/Update/Tips";
import { agreementStatusEnum } from "@/utils/enum";

class ConfirmUpdateAgreement extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: null, isFuture: false };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.agreement
      .getLoginProtocal({ isSubUser: false })
      .then((response) => {
        if (response?.list && response?.list?.length > 0) {
          this.setState(
            {
              data: {
                content: response?.list[0],
                secureToken: response?.secureToken,
              },
            },
            () => {
              this.fetchTime();
            }
          );
        } else {
          const { updateStatus } = this.props;
          updateStatus && updateStatus(agreementStatusEnum.agreementUpdated);
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  fetchTime = () => {
    const { data } = this.state;
    const content = data?.content;
    if (content) {
      api.common
        .getTime()
        .then((response) => {
          const isFuture =
            moment(content?.updateDate).format("YYYYMMDD") >
            moment(response).format("YYYYMMDD");
          const { updateStatus } = this.props;
          updateStatus &&
            updateStatus(agreementStatusEnum.agreementWillUpdate, isFuture);
          this.setState({ isFuture });
        })
        .catch((error) => {
          console.error("error: " + error.message);
        });
    }
  };

  next = () => {
    const { data } = this.state;
    const { authentication } = this.props;
    const content = data?.content;
    api.agreement
      .updateLoginProtocal({
        userid: authentication?.accountId,
        secureToken: data?.secureToken,
        version: content?.version,
      })
      .then(() => {
        const { updateStatus } = this.props;
        updateStatus && updateStatus(agreementStatusEnum.agreementUpdated);
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  header = () => {
    const { isFuture, data } = this.state;
    const content = data?.content;
    return (
      <ConfirmUpdateTips
        className="confirm-update-agreement-container-tips"
        text={
          isFuture
            ? moment(content?.updateDate).format(
                i18n.t("TCCs0020_confirm_update_agreement_future_tips")
              )
            : i18n.t("TCCs0020_confirm_update_agreement_tips")
        }
      />
    );
  };

  render() {
    const {
      data,
      // 課金-ADD-START
      isFuture,
      // 課金-ADD-END
    } = this.state;
    const content = data?.content;
    return (
      <ConfirmBody
        className="confirm-update-agreement-container"
        header={this.header()}
        title={i18n.t("TCCs0020_confirm_update_agreement_content_title")}
        confirmButtonText={i18n.t(
          "TCCs0020_confirm_update_agreement_button_title"
        )}
        content={content?.contentText}
        onClick={this.next}
        // 課金-ADD-START
        downloadUrl={i18n.t(
          isFuture
            ? "agreement_future_version_download_url"
            : "agreement_applicable_version_download_url"
        )}
        // 課金-ADD-END
        showCheckbox={false}
        notNeedRead={true}
      />
    );
  }
}

ConfirmUpdateAgreement.propTypes = {
  updateStatus: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
    authentication: state?.user?.authentication,
  };
};

export default connect(mapStateToProps)(ConfirmUpdateAgreement);
